import { type PropsWithChildren } from 'react';

import {
  Box,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react';
import { motion } from 'framer-motion';

const MotionBox = motion(Box);

type BottomSheetProps = PropsWithChildren<{
  isOpen: boolean;
  onClose: () => void;
  headerTitle?: string;
  closeButton?: boolean;
}>;

export const BottomSheet = ({
  isOpen,
  onClose,
  children,
  headerTitle,
  closeButton = true,
}: BottomSheetProps) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        bg="white"
        position="fixed"
        bottom="0"
        left="0"
        right="0"
        width="100vw"
        margin="auto"
        borderTopRadius="xl"
        borderBottomRadius="none"
        overflow="hidden"
        as={MotionBox}
        initial={{ y: '100%' }}
        animate={{ y: 0 }}
        exit={{ y: '100%' }}
      >
        {headerTitle && <ModalHeader>{headerTitle}</ModalHeader>}

        {closeButton && <ModalCloseButton />}

        <ModalBody>
          <Box>{children}</Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
